import { useEffect } from 'react';
import { isValidURL } from '@/utils';

const loadCssFile = (href: string) => {
  const link = document.createElement('link');
  link.href = href;
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.media = 'screen,print';
  document.head.appendChild(link);
  return link;
};

const loadCssSnippet = (css: string) => {
  const style = document.createElement('style');
  style.type = 'text/css';
  style.appendChild(document.createTextNode(css));
  document.getElementsByTagName('head')[0].appendChild(style);
  return style;
};

export interface UseStylesheetsOptions {
  stylesheets: string[];
}

export function useStylesheets({
  stylesheets,
}: {
  stylesheets: string[];
}): void {
  useEffect(() => {
    const stylesheetElements = stylesheets.map(
      (stylesheet: string): HTMLLinkElement | HTMLStyleElement => {
        if (isValidURL(stylesheet)) {
          return loadCssFile(stylesheet);
        } else {
          return loadCssSnippet(stylesheet);
        }
      }
    );
    return () => {
      stylesheetElements.forEach((stylesheetElement) => {
        stylesheetElement.remove();
      });
    };
  }, []);
}
